(ns practitest.frontend.user-activity-log.views
  (:require
   [clojure.string :as str]
   [re-frame.core :as re-frame]
   [practitest.frontend.common.re-frame :refer [partial-dispatch]]
   [practitest.frontend.components2.grid :as grid2]
   [practitest.frontend.user-activity-log.subs :as user-activity-log-subs]
   [practitest.frontend.common-entities.events :as common-events]
   [practitest.frontend.components.grid.subs :as grid.subs]
   [practitest.frontend.components.grid.localstorage :as grid-storage]
   [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [reagent.core :as reagent]))

(def current-entity :user-activity-log)
(def state-key :user-activity-log-index)

(defn build-columns [account-projects]
  [{:autofilter? true
    :default-width 200
    :field :user_name
    :header (get-translation "user-activity-log.column.user-name" "User Name")
    :type :text}
   {:autofilter? true
    :default-width 250
    :field :email
    :header (get-translation "user-activity-log.column.email" "Email")
    :type :text}
   {:default-width 200
    :field :last_active_time
    :header (get-translation "user-activity-log.column.last-active-time" "Last Active Time")
    :type :date-time}
   {:autofilter? true
    :default-width 300
    :field :projects
    :display-field :user_groups_per_projects
    :header (get-translation "user-activity-log.column.projects" "Project/s")
    :type :multilist
    :multiple? true
    :possible-values account-projects}])

(defn- add-projects-title [entries]
  (mapv (fn [entry]
          (assoc entry :projects_title (str/join "; " (:user_groups_per_projects entry))))
        entries))

(defn user-activity-log-grid [grid-state]
  (let [table-id "user-activity-log-index"
        entries (add-projects-title @(re-frame/subscribe [::user-activity-log-subs/get-all-entries]))
        account-projects @(re-frame/subscribe [::user-activity-log-subs/account-projects])
        grid-props {:columns (build-columns account-projects)
                    :table-id table-id
                    :grid-state grid-state
                    :local-state-updating grid-state
                    :full-data? true
                    :expanded? @(re-frame/subscribe [::grid.subs/expanded? current-entity state-key])
                    :on-expand-click (partial-dispatch [::common-events/toggle-expanded current-entity state-key])
                    :current-page-load (reagent/partial grid-storage/load-current-page table-id)
                    :current-page-save (reagent/partial grid-storage/save-current-page table-id)
                    :per-page-save (reagent/partial grid-storage/save-per-page table-id)
                    :per-page-load (reagent/partial grid-storage/load-per-page table-id)
                    :sort-order-save (reagent/partial grid-session-storage/save-sort-order table-id)
                    :sort-order-load (reagent/partial grid-session-storage/load-sort-order table-id)
                    :data entries
                    :resizable? true
                    :class "admin-page-table"}]
    [:div.user-activity-log-grid
     [grid2/grid grid-props]]))

(defn main-panel []
  (let [grid-state (reagent/atom {:module "user-activity-log"})]
    [:div.user-activity-log-page
     [user-activity-log-grid grid-state]]))
